(function () {
    "use strict";

    var UserParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.UserParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentUser = this.initialParameterValue;
        });


    UserParameterControl.preload = function (newValue, callback) {
        if (newValue && newValue.userId) {
            Solovis.Rpc.invoke(
                "~/Selectors/UserSelector/GetUserData", { userId: newValue.userId },
                function (response, success) {
                    if (success) {
                        var userData = response.result;                        
                        callback(userData, true);
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else {        
            callback(null, true);
        }
    };

    UserParameterControl.serializeParameterValue = function (value) {
        if (value) {
            if (value.userId) {
                return { userId: value.userId };
            }            
        }

        return null;
    };

    UserParameterControl.getLabel = function (value): string | undefined {
      if (value?.fullName && value?.primaryEmail) {
        return value.fullName + " - " + value.primaryEmail;
      }
    };

   
    UserParameterControl.prototype.doInit = function () {        
    };

    UserParameterControl.prototype.doRender = function () {
        var self = this;
        
        this.selectedUserLabel = $("<a>").appendTo(this.container)
            .click(function (e) {
                if (self.currentUser && self.currentUser.userId) {
                    Solovis.UI.PopupLinkPanel.showLinks({
                        offset: { left: e.pageX, top: e.pageY },
                        links: Solovis.Reports.ReportLinker.getUserLinks(self.currentUser.userId)
                    });
                }
            });
        this.selectUserLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);
     
        this.selectUserLink.click(function () {
            self._toggleSelectorDialog(function (user) {
                self._setCurrentUserData(user);
                self.notifyParameterValueChanged();
            });
        });

        // Set initial parameter value text.
        if (this.currentUser) {
            this._setCurrentUserData(this.currentUser);
        }
    };

    UserParameterControl.prototype._setCurrentUserData = function (userData) {
        this.currentUser = userData;
        if (this.currentUser) {
            this.selectedUserLabel.text(UserParameterControl.getLabel(this.currentUser) + " ");
        }
        else {
            this.selectedUserLabel.text("");
        }
    };

    UserParameterControl.prototype.setParameterValue = function (newValue) {        
        this._setCurrentUserData(newValue);        
    };

    UserParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this.currentUser) {
            return Solovis.deepCopy(this.currentUser);
        }
        else {
            return null;
        }
    };

    UserParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };


    UserParameterControl.prototype._toggleSelectorDialog = function (selectionCallback) {
        var self = this;

        if (this._selectionDialog) {
            // We already have the selection dialog open, so close it.
            this._selectionDialog.close();
            this._selectionDialog = null;
            return;
        }


        var selectorControlHostDiv = $("<div>");
        var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
        var selectorControl = new (Solovis.InvDataSelectors as any).UserSelectorControl({
            controlHost: selectorControlHostDiv,
            selectionCallback: function (contact) {
                selectionCallback(contact);
                self._selectionDialog.close();
            },
            cancelCallback: function () {
                self._selectionDialog.close();
            }
        });
        selectorControlHost.setCurrentControl(selectorControl);


        // Determine dialog position.        
        var linkOffset = $(this.selectedUserLabel).offset();
        var linkHeight = $(this.selectUserLink).outerHeight();
        var dialogPosition = {
            left: linkOffset.left,
            top: linkOffset.top + linkHeight + 5
        };

        var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

        this._selectionDialog = new Solovis.UI.Dialog({
            container: selectorControlHostDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: false,
            autoOpen: true,
            destroyOnClose: true,
            actions: ["Close"],
            noAnimation: true,
            position: adjustedPosition,

            buttons: [
                {
                    label: "Clear",
                    click: function () {
                        selectionCallback(null);
                        self._selectionDialog.close();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._selectionDialog.close();
                    }
                }
            ],

            activate: function () {
                selectorControl.focus();
            },

            deactivate: function () {
                self._selectionDialog = null;
            }
        });
    };

})();